import { z } from "zod";
import { isoDate } from "./dates";

/** Különleges főkönyvi számlák a feladáshoz (magyar számlatükör szerinti javaslattal). */
export const GL_SPECIAL = {
  RECEIVABLE: { label: "Vevők (ellenszámla a kiállított számlákhoz)", default: "311" },
  PAYABLE: { label: "Szállítók (ellenszámla a költségekhez)", default: "454" },
  VAT_OUT: { label: "Fizetendő áfa", default: "467" },
  VAT_IN: { label: "Előzetesen felszámított áfa", default: "466" },
  RECHARGE_COST: { label: "Továbbszámlázott szolgáltatás beszerzési értéke (pl. 8151, ha így könyvelitek; üresen a költségkategória száma)", default: "" },
  RECHARGE_REVENUE: { label: "Továbbszámlázott költség bevétele", default: "" },
  RECONCILIATION: { label: "Üzemeltetési elszámolás különbözete", default: "" },
  MANUAL: { label: "Kézi számlatétel (alapértelmezés)", default: "" },
} as const;
export type GlSpecialKey = keyof typeof GL_SPECIAL;

export const glMapSchema = z.object({
  kind: z.enum(["CHARGE_TYPE", "COST_CATEGORY", "SPECIAL"]),
  refKey: z.string().trim().min(1).max(60),
  /** Üres: a leképezés törlése (a katalógus szerinti szám érvényes) */
  glAccount: z.string().trim().max(20),
});
export const glMapBulkSchema = z.object({ items: z.array(glMapSchema).max(300) });

export const glExportSchema = z.object({
  from: isoDate,
  to: isoDate,
  legalEntityId: z.string().uuid().optional(),
  include: z.enum(["all", "invoices", "expenses"]).default("all"),
  format: z.enum(["json", "csv", "xlsx"]).default("json"),
});

export const reportFormat = z.enum(["json", "csv", "xlsx"]).default("json");
